const SCHEMA_VERSION = 1;
const KEY_PREFIX = "invoice-workflow";

function clean(value) {
  return String(value ?? "").trim();
}

export function invoiceWorkflowSessionKey(projectId, viewerUid) {
  const project = clean(projectId);
  const viewer = clean(viewerUid);
  if (!project || !viewer) return "";
  return `${KEY_PREFIX}:${encodeURIComponent(project)}:${encodeURIComponent(viewer)}`;
}

export function readInvoiceWorkflowSession(projectId, viewerUid) {
  const key = invoiceWorkflowSessionKey(projectId, viewerUid);
  if (!key || typeof window === "undefined" || !window.sessionStorage) return null;
  try {
    const parsed = JSON.parse(window.sessionStorage.getItem(key) || "null");
    if (!parsed || parsed.schemaVersion !== SCHEMA_VERSION) return null;
    return {
      schemaVersion: SCHEMA_VERSION,
      mode: ["select-time", "build", "review"].includes(parsed.mode) ? parsed.mode : "select-time",
      entryIds: Array.isArray(parsed.entryIds) ? parsed.entryIds.map(clean).filter(Boolean) : [],
      dateFrom: clean(parsed.dateFrom),
      dateTo: clean(parsed.dateTo),
      updatedAt: clean(parsed.updatedAt),
    };
  } catch {
    return null;
  }
}

export function writeInvoiceWorkflowSession(projectId, viewerUid, value = {}) {
  const key = invoiceWorkflowSessionKey(projectId, viewerUid);
  if (!key || typeof window === "undefined" || !window.sessionStorage) return null;
  const record = {
    schemaVersion: SCHEMA_VERSION,
    mode: ["select-time", "build", "review"].includes(value.mode) ? value.mode : "select-time",
    entryIds: Array.isArray(value.entryIds) ? value.entryIds.map(clean).filter(Boolean) : [],
    dateFrom: clean(value.dateFrom),
    dateTo: clean(value.dateTo),
    updatedAt: new Date().toISOString(),
  };
  try {
    window.sessionStorage.setItem(key, JSON.stringify(record));
    return record;
  } catch {
    return null;
  }
}

export function clearInvoiceWorkflowSession(projectId, viewerUid) {
  const key = invoiceWorkflowSessionKey(projectId, viewerUid);
  if (!key || typeof window === "undefined" || !window.sessionStorage) return;
  try {
    window.sessionStorage.removeItem(key);
  } catch {
    // Storage can be unavailable in privacy-restricted browser contexts.
  }
}
